import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-show-open-days-dialog',
  templateUrl: './show-open-days-dialog.component.html',
  styleUrls: ['./show-open-days-dialog.component.scss'],
})
export class ShowOpenDaysDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ShowOpenDaysDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public componentData: any
  ) {}

  dates = [];
  ngOnInit(): void {
    this.dates = this.componentData.dates;
  }

  close() {
    this.dialogRef.close();
  }

  gotoDate(d: any) {
    this.dialogRef.close({date: d});
  }

  printAsDate(date: number) {
    return new Date(date).toLocaleDateString("de-DE", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
  }
}
